import axiosInstance from "../config/axiosInstance";

const BASE_URL = "/securitypermission";

/**
 * Obtiene una lista paginada de permisos.
 * @param {number} pageIndex
 * @param {number} pageSize
 * @param {string|null} searchTerm
 * @returns {Promise<ApiResponse<PaginatedResult<SecurityPermissionDto>>>}
 */
export const getPagedPermissions = async (
  pageIndex = 1,
  pageSize = 10,
  searchTerm = null
) => {
  const response = await axiosInstance.get(`${BASE_URL}/paged`, {
    params: { pageIndex, pageSize, searchTerm },
  });
  return response.data;
};

/**
 * Obtiene un permiso por su ID.
 * @param {Guid} id
 * @returns {Promise<ApiResponse<SecurityPermissionDto>>}
 */
export const getPermissionById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * Crea un nuevo permiso.
 * @param {CreateSecurityPermissionDto} data
 * @returns {Promise<ApiResponse<SecurityPermissionDto>>}
 */
export const createPermission = async (data) => {
  const response = await axiosInstance.post(`${BASE_URL}`, data);
  return response.data;
};

/**
 * Actualiza un permiso existente.
 * @param {UpdateSecurityPermissionDto} data
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const updatePermission = async (data) => {
  const response = await axiosInstance.put(`${BASE_URL}/${data.id}`, data);
  return response.data;
};

/**
 * Elimina un permiso por su ID.
 * @param {Guid} id
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const deletePermission = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};
/**
 * Obtiene la lista de acciones únicas ya utilizadas en la base de datos.
 * @returns {Promise<ApiResponse<string[]>>}
 */
export const getUniqueActions = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/actions`);
  return response.data;
};

/**
 * Obtiene la lista de módulos únicos ya utilizados en la base de datos.
 * @returns {Promise<ApiResponse<string[]>>}
 */
export const getUniqueModules = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/modules`);
  return response.data;
};

export const getAllPermissions = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/GetAll`);
  return response.data;
};
